export default __webpack_public_path__ + "static/media/high_dot.110f8ddc.svg";